<app-tooltip [message]="tooltip" [dynamic]="false" class="display-inline-flex">
  <button (click)="click()"
    [attr.class]="class"
    [attr.data-cy]="dataCy"
    [attr.disabled]="disabled ? 'disabled' : null"
    [attr.id]="id">
    @if (icon) {
      <span [ngClass]="[icon,'sticky-header-simple-button-icon']"></span>
    }
    <span>{{text}}</span>
  </button>
  @if (loading) {
    <app-loading-spinner class="button-spinner"></app-loading-spinner>
  }
</app-tooltip>
